export var Global = {
    // url:'http://localhost/server_external/public/api',
    // url: 'https://172.176.145.53/server_external/api',
    url: 'https://portalclientesserver.lavoroperu.pe/api',
};